/* Zwalnianie obrazkow poza kadrem na listingu (25.09.2026, crash Safari iOS).

   Kontekst: `collection-auto-load.js` ogranicza AUTOMATYCZNE doladowania do
   trzech, i to dziala - przewijanie samo zatrzymuje sie na stronie 4. Ale
   przycisk "Pokaz wiecej" nie ma zadnego sufitu, wiec klikajac dalej mozna
   dojsc do konca kolekcji. Zmierzone na `/collections/wszystkie-produkty`:
   po dojsciu do strony 16 w DOM siedzi 265 kafli i 793 elementy `<img>`
   (kazdy kafel ma trzy: dwa zdjecia galerii + swatch). Tyle zdekodowanych
   bitmap iOS nie utrzyma i Safari ubija karte.

   `content-visibility:auto` z `section-listing.css` zdejmuje koszt RENDEROWANIA,
   ale nie zwalnia zdekodowanych obrazkow - a to one zjadaja pamiec. Dlatego tu
   idziemy do zrodla: kafel, ktory odjechal wystarczajaco daleko od kadru, ma
   zdejmowane `src` i `srcset`. Adresy ladują do `data-budget-*`, wiec powrot
   jest darmowy - przegladarka bierze plik z cache, nie z sieci.

   Dlaczego IntersectionObserver, a nie liczenie pozycji na `scroll`: przy 265
   kaflach odczyt `getBoundingClientRect()` w petli to praca na kazda klatke.
   Obserwator robi to samo poza watkiem glownym i budzi nas tylko przy zmianie.

   `ZAPAS` to 150% wysokosci okna w gore i w dol - kafel wraca do zycia grubo
   zanim gracz go zobaczy, wiec przy normalnym przewijaniu nikt nie zlapie
   pustego miejsca. Przy rzucie paskiem na sam dol moze mignac - to swiadomy
   kompromis, alternatywa jest ubita karta.

   `PROG` pilnuje, zeby nie ruszac niczego przy zwyklym wejsciu na kolekcje.
   Jedna strona to 16 kafli; dopiero kilka doladowan robi z tego problem. */
(function () {
  var ZAPAS = '150% 0px';
  var PROG = 60; /* ponizej tylu kafli nie ma czego ratowac */
  var PUSTY = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

  var obserwator = null;
  var aktywny = false;

  function kafle() {
    return document.querySelectorAll('.listing__grid > product-card');
  }

  /* Zdejmujemy zarowno `<source srcset>` (picture) jak i `<img src/srcset>`.
     Samo wyczyszczenie `<img>` nie wystarcza - dopoki `<source>` ma adres,
     przegladarka dalej trzyma wybrany wariant. */
  function zwolnij(kafel) {
    if (kafel.dataset.budgetZwolniony === '1') return;

    kafel.querySelectorAll('source[srcset]').forEach(function (zrodlo) {
      zrodlo.dataset.budgetSrcset = zrodlo.getAttribute('srcset');
      zrodlo.removeAttribute('srcset');
    });

    kafel.querySelectorAll('img').forEach(function (obraz) {
      if (obraz.getAttribute('srcset')) {
        obraz.dataset.budgetSrcset = obraz.getAttribute('srcset');
        obraz.removeAttribute('srcset');
      }
      var src = obraz.getAttribute('src');
      if (src && src !== PUSTY) {
        obraz.dataset.budgetSrc = src;
        obraz.setAttribute('src', PUSTY);
      }
    });

    kafel.dataset.budgetZwolniony = '1';
  }

  function przywroc(kafel) {
    if (kafel.dataset.budgetZwolniony !== '1') return;

    kafel.querySelectorAll('source[data-budget-srcset]').forEach(function (zrodlo) {
      zrodlo.setAttribute('srcset', zrodlo.dataset.budgetSrcset);
      delete zrodlo.dataset.budgetSrcset;
    });

    kafel.querySelectorAll('img').forEach(function (obraz) {
      if (obraz.dataset.budgetSrcset) {
        obraz.setAttribute('srcset', obraz.dataset.budgetSrcset);
        delete obraz.dataset.budgetSrcset;
      }
      if (obraz.dataset.budgetSrc) {
        obraz.setAttribute('src', obraz.dataset.budgetSrc);
        delete obraz.dataset.budgetSrc;
      }
    });

    delete kafel.dataset.budgetZwolniony;
  }

  /* Siatka bezpieczenstwa. IntersectionObserver dostarcza callbacki dopiero
     przy okazji renderowania - gdy karta jest zdlawiona (nieaktywna zakladka,
     obciazony watek), potrafi milczec. Sam w sobie to nie problem, ale gdyby
     milczal akurat po zwolnieniu kafli, uzytkownik zobaczylby puste miejsca.

     Dlatego dubel na dlawionym `scroll`: przechodzi po ZWOLNIONYCH kaflach i
     przywraca te, ktore sa w pasmie. Ta sciezka celowo potrafi tylko oddac
     obrazki, nigdy ich nie zdjac - zwalnianie zostaje wylacznie w gestii
     obserwatora. Najgorszy mozliwy skutek awarii to wiecej obrazkow w pamieci,
     nigdy pusty kafel. */
  function przywrocWidoczne() {
    var zwolnione = document.querySelectorAll('.listing__grid > product-card[data-budget-zwolniony="1"]');
    if (!zwolnione.length) return;

    var gora = -window.innerHeight;
    var dol = window.innerHeight * 2;

    zwolnione.forEach(function (kafel) {
      var r = kafel.getBoundingClientRect();
      if (r.bottom > gora && r.top < dol) przywroc(kafel);
    });
  }

  var czekaNaKlatke = false;

  function naPrzewijaniu() {
    if (czekaNaKlatke) return;
    czekaNaKlatke = true;
    setTimeout(function () {
      czekaNaKlatke = false;
      przywrocWidoczne();
    }, 250);
  }

  function podepnij() {
    var lista = kafle();

    if (lista.length < PROG) {
      /* Zeszlismy ponizej progu (np. po zmianie filtrow) - oddajemy wszystko. */
      if (aktywny) {
        if (obserwator) obserwator.disconnect();
        lista.forEach(przywroc);
        aktywny = false;
      }
      return;
    }

    if (obserwator) obserwator.disconnect();

    obserwator = new IntersectionObserver(function (wpisy) {
      wpisy.forEach(function (wpis) {
        if (wpis.isIntersecting) {
          przywroc(wpis.target);
        } else {
          zwolnij(wpis.target);
        }
      });
    }, { rootMargin: ZAPAS });

    lista.forEach(function (kafel) {
      obserwator.observe(kafel);
    });

    aktywny = true;
  }

  /* Doladowanie strony i zmiana filtrow podmieniaja zawartosc siatki, wiec
     nowe kafle trzeba objac obserwatorem. Odpalamy z opoznieniem, bo
     `filters.js` wstawia cala partie naraz. */
  function pilnuj() {
    var listing = document.querySelector('[data-listing]');
    if (!listing) return;
    var czeka = null;
    new MutationObserver(function () {
      clearTimeout(czeka);
      czeka = setTimeout(podepnij, 150);
    }).observe(listing, { childList: true, subtree: true });
  }

  function start() {
    if (!('IntersectionObserver' in window)) return;
    if (!document.querySelector('.listing__grid')) return;
    podepnij();
    pilnuj();
    window.addEventListener('scroll', naPrzewijaniu, { passive: true });
    window.addEventListener('resize', naPrzewijaniu, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
